import {
  BookUser,
  BotMessageSquare,
  Building2,
  Contact2,
  Gauge,
  Handshake,
  Home,
  LayoutDashboard,
  LayoutList,
  List,
  Search,
  Send,
  Settings2,
  TrendingUp,
  UserSearch,
} from 'lucide-react';
import { getJobsLink } from '../helpers/urlHelpers';

export const useMainMenu = (activeNetwork) => {
  const topItems = [];
  const crmItems = [];
  const researchItems = [];
  const jobBoardItems = [];
  const { isManager, features, connect } = activeNetwork;
  const isJobBoardEnabled = features && features.includes('job_board');

  // Top items (no section header)
  if (connect?.hasAccess) {
    topItems.push({
      icon: Home,
      label: 'Home',
      path: `/networks/${activeNetwork.slug}/home`,
    });
  }

  topItems.push({
    icon: BotMessageSquare,
    label: 'AI Agents',
    href: 'https://www.getro.com/agents',
    path: '',
    type: 'external',
    isBeta: true,
  });

  if (isManager && (connect?.hasAccess || features?.includes('job_board'))) {
    topItems.push({
      icon: TrendingUp,
      label: 'Analytics',
      path: `/networks/${activeNetwork.slug}/analytics`,
    });
  }

  if (activeNetwork.organization) {
    const company = activeNetwork.organization;
    topItems.push({
      icon: LayoutDashboard,
      path: `/networks/${activeNetwork.slug}/company-profile/${company.id}-${company.slug}`,
      label: 'Company Profile',
    });
  }

  // CRM section (collapsible)
  crmItems.push({
    icon: Contact2,
    label: 'Contacts',
    path: `/networks/${activeNetwork.slug}/contacts`,
    showUpgradeIcon: !connect?.hasAccess,
  });

  if (connect?.hasAccess) {
    crmItems.push({ icon: List, label: 'Lists', path: `/networks/${activeNetwork.slug}/lists` });
  }

  crmItems.push({
    icon: Send,
    label: 'Campaigns',
    path: `/networks/${activeNetwork.slug}/crm`,
    // TODO: add condition to show upgrade icon
    showUpgradeIcon: true,
  });

  // Research section (collapsible)
  researchItems.push({
    icon: UserSearch,
    label: 'People Finder',
    path: `/networks/${activeNetwork.slug}/projects`,
    // TODO: add condition to show upgrade icon
    showUpgradeIcon: true,
  });

  researchItems.push({
    icon: Building2,
    label: 'Company Research',
    path: `/networks/${activeNetwork.slug}/company-research`,
    // TODO: add condition to show upgrade icon
    showUpgradeIcon: true,
  });

  // Job Board section
  if (isJobBoardEnabled) {
    jobBoardItems.push({
      icon: Gauge,
      label: 'Dashboard',
      path: `/networks/${activeNetwork.slug}/dashboard`,
    });
    jobBoardItems.push({
      icon: Building2,
      label: 'Companies',
      path: `/networks/${activeNetwork.slug}/companies`,
    });
    jobBoardItems.push({
      icon: LayoutList,
      label: 'Jobs',
      path: getJobsLink({ networkSlug: activeNetwork.slug }),
    });
    jobBoardItems.push({
      icon: Handshake,
      label: 'Hires',
      path: `/networks/${activeNetwork.slug}/hires`,
    });
    jobBoardItems.push({
      icon: Settings2,
      label: 'Settings',
      path: `/networks/${activeNetwork.slug}/settings/job-board`,
    });
  }

  const jobBoardSection = isJobBoardEnabled
    ? { label: 'Job Board', icon: LayoutList, items: jobBoardItems, sectionKey: 'jobBoard' }
    : {
        label: 'JobBoardIntro',
        items: [
          {
            icon: LayoutList,
            label: 'Job Board',
            path: `/networks/${activeNetwork.slug}/job-board-intro`,
            showUpgradeIcon: true,
          },
        ],
      };

  const items = [
    { label: 'Top', items: topItems },
    ...(isManager
      ? [
          { label: 'CRM', icon: BookUser, items: crmItems, sectionKey: 'crm', separator: true },
          { label: 'Research', icon: Search, items: researchItems, sectionKey: 'research' },
        ]
      : []),
    jobBoardSection,
  ].filter((section) => section.items.length > 0);

  return { items };
};
